import { render, staticRenderFns } from "./EditorPaperless.vue?vue&type=template&id=477add22&scoped=true&"
import script from "./EditorPaperless.vue?vue&type=script&lang=js&"
export * from "./EditorPaperless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477add22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477add22')) {
      api.createRecord('477add22', component.options)
    } else {
      api.reload('477add22', component.options)
    }
    module.hot.accept("./EditorPaperless.vue?vue&type=template&id=477add22&scoped=true&", function () {
      api.rerender('477add22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorPaperless.vue"
export default component.exports